import React from 'react';
import CardHomeBox from '../CardHomeBox/index';
import Search from '../../../img/procurar.svg';
import Group from '../../../img/grupo.svg';
import Analise from '../../../img/analise.svg';
import { Title, BoxHome } from './style';

const HomeBox = () => (
	<BoxHome>
		<Title>Por que é necessário <br /> ter campanha?</Title>
		<div className="row" style={{ marginBottom: '1px', padding: '0 23px' }}>
			<div className="col-md-12 col-lg-4 col-xl-4">
				<CardHomeBox
					icon={Search}
					altIcon=""
					titleIcon="Logo"
					title="Jornada de"
					titleRed="compra automotiva"
					text="95% dos consumidores buscam a internet como fonte
                    de informação do setor automotivo e 91% iniciam a jornada
                    de compra de um carro por meio digital."
				/>
			</div>
			<div className="col-12 col-lg-4 col-xl-4">
				<CardHomeBox
					icon={Group}
					altIcon=""
					titleIcon="Alvo"
					title="A Era do"
					titleRed="e-commerce de carros"
					text="Já é possível realizar uma compra de um carro do início
                    ao fim pela internet, incluindo até mesmo a contratação de um
                    financiamento. Você vai ficar de fora?"
				/>
			</div>
			<div className="col-12 col-lg-4 col-xl-4">
				<CardHomeBox
					icon={Analise}
					altIcon=""
					titleIcon="Landing Page"
					title="Esteja além"
					titleRed="da concorrência"
					text="Saia na frente da concorrência investindo onde os clientes estão.
                    As campanhas colocam suas ofertas no lugar certo e na hora certa!
                    Esteja onde seus clientes estão."
				/>
			</div>
		</div>
	</BoxHome>
);

export default HomeBox;
